<template>
  <article>
    <h1 class="text-h3" id="about" v-intersect="onIntersect">Credits and Licenses</h1>
    <p>List of software vendors and attributions for the code used to build our products.</p>
    <p>
      Below is a list of software vendors and attributions for the code used to build our products. AlphaX is both a contributor and user of open source
      software. We thank the community and look forward to continuing our contributions.
    </p>

    <h2 class="text-h4" id="python" v-intersect="onIntersect">Python packages</h2>
    
    <v-card flat outlined color="grey">
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Name</th>
            <th>Version</th>
            <th>License</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Automat</td>
            <td>22.10.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>Deprecated</td>
            <td>1.2.13</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>Django</td>
            <td>3.2.16</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>Keras-Preprocessing</td>
            <td>1.1.2</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>Markdown</td>
            <td>3.4.1</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>MarkupSafe</td>
            <td>2.1.1</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>PyJWT</td>
            <td>2.6.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>SQLAlchemy</td>
            <td>1.4.42</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>Twisted</td>
            <td>22.10.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>Werkzeug</td>
            <td>2.2.2</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>absl-py</td>
            <td>1.3.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>amqp</td>
            <td>5.1.1</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>asgiref</td>
            <td>3.5.2</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>astunparse</td>
            <td>1.6.3</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>async-timeout</td>
            <td>4.0.2</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>attrs</td>
            <td>22.1.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>autobahn</td>
            <td>22.7.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>billiard</td>
            <td>3.6.4.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>black</td>
            <td>22.6.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>cached-property</td>
            <td>1.5.2</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>cachetools</td>
            <td>5.2.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>celery</td>
            <td>5.2.7</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>certifi</td>
            <td>2022.12.7</td>
            <td>Mozilla Public License 2.0 (MPL 2.0)</td>
          </tr>
          <tr>
            <td>cffi</td>
            <td>1.15.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>channels</td>
            <td>4.0.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>channels-redis</td>
            <td>4.0.0</td>
            <td>BSD</td>
          </tr>
          <tr>
            <td>charset-normalizer</td>
            <td>2.1.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>click</td>
            <td>8.1.3</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>click-didyoumean</td>
            <td>0.3.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>click-plugins</td>
            <td>1.1.1</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>click-repl</td>
            <td>0.2.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>colorama</td>
            <td>0.4.6</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>coloredlogs</td>
            <td>15.0.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>constantly</td>
            <td>15.1.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>cryptography</td>
            <td>38.0.1</td>
            <td>Apache Software License; BSD License</td>
          </tr>
          <tr>
            <td>daphne</td>
            <td>4.0.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>django-celery-results</td>
            <td>2.4.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>django-cors-headers</td>
            <td>3.13.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>django-encrypted-model-fields</td>
            <td>0.6.5</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>django-environ</td>
            <td>0.9.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>django-extensions</td>
            <td>3.2.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>django-filter</td>
            <td>22.1</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>django-redis</td>
            <td>5.2.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>django-restql</td>
            <td>0.15.3</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>djangorestframework</td>
            <td>3.14.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>djangorestframework-simplejwt</td>
            <td>5.2.2</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>drf-flex-fields</td>
            <td>1.0.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>et-xmlfile</td>
            <td>1.1.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>flatbuffers</td>
            <td>22.10.26</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>flit-core</td>
            <td>3.6.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>flower</td>
            <td>1.2.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>gast</td>
            <td>0.4.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>google-auth</td>
            <td>2.14.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>google-auth-oauthlib</td>
            <td>0.4.6</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>google-pasta</td>
            <td>0.2.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>greenlet</td>
            <td>2.0.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>grpcio</td>
            <td>1.50.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>gunicorn</td>
            <td>20.1.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>h2</td>
            <td>4.1.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>h5py</td>
            <td>3.7.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>hpack</td>
            <td>4.0.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>humanfriendly</td>
            <td>10.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>humanize</td>
            <td>4.4.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>hyperframe</td>
            <td>6.0.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>hyperlink</td>
            <td>21.0.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>idna</td>
            <td>3.4</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>importlib-metadata</td>
            <td>4.13.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>incremental</td>
            <td>22.10.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>joblib</td>
            <td>1.2.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>keras</td>
            <td>2.10.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>kombu</td>
            <td>5.2.4</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>libclang</td>
            <td>14.0.6</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>msgpack</td>
            <td>1.0.4</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>mypy-extensions</td>
            <td>0.4.3</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>numpy</td>
            <td>1.21.6</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>oauthlib</td>
            <td>3.2.2</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>openpyxl</td>
            <td>3.0.10</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>opt-einsum</td>
            <td>3.3.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>packaging</td>
            <td>21.3</td>
            <td>Apache Software License; BSD License</td>
          </tr>
          <tr>
            <td>pandas</td>
            <td>1.3.5</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>pathspec</td>
            <td>0.9.0</td>
            <td>Mozilla Public License 2.0 (MPL 2.0)</td>
          </tr>
          <tr>
            <td>platformdirs</td>
            <td>2.5.2</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>priority</td>
            <td>1.3.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>prometheus-client</td>
            <td>0.15.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>prompt-toolkit</td>
            <td>3.0.31</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>protobuf</td>
            <td>3.19.6</td>
            <td>3-Clause BSD License</td>
          </tr>
          <tr>
            <td>psycopg2-binary</td>
            <td>2.9.5</td>
            <td>GNU Library or Lesser General Public License (LGPL)</td>
          </tr>
          <tr>
            <td>pyOpenSSL</td>
            <td>22.1.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>pyPEG2</td>
            <td>2.15.2</td>
            <td>GNU General Public License v2 (GPLv2)</td>
          </tr>
          <tr>
            <td>pyasn1</td>
            <td>0.4.8</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>pyasn1-modules</td>
            <td>0.2.8</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>pycparser</td>
            <td>2.21</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>pyodbc</td>
            <td>4.0.34</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>pyotp</td>
            <td>2.7.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>pyparsing</td>
            <td>3.0.9</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>pyreadline</td>
            <td>2.1</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>python-dateutil</td>
            <td>2.8.2</td>
            <td>Apache Software License; BSD License</td>
          </tr>
          <tr>
            <td>pytz</td>
            <td>2022.6</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>redis</td>
            <td>4.3.4</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>requests</td>
            <td>2.28.1</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>requests-oauthlib</td>
            <td>1.3.1</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>rest-framework-generic-relations</td>
            <td>2.1.0</td>
            <td>BSD</td>
          </tr>
          <tr>
            <td>rsa</td>
            <td>4.9</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>scikit-learn</td>
            <td>0.22.2</td>
            <td>new BSD</td>
          </tr>
          <tr>
            <td>scipy</td>
            <td>1.7.3</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>service-identity</td>
            <td>21.1.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>simplejson</td>
            <td>3.17.6</td>
            <td>Academic Free License (AFL); MIT License</td>
          </tr>
          <tr>
            <td>six</td>
            <td>1.16.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>sqlparse</td>
            <td>0.4.3</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>tensorboard</td>
            <td>2.10.1</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>tensorboard-data-server</td>
            <td>0.6.1</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>tensorboard-plugin-wit</td>
            <td>1.8.1</td>
            <td>Apache 2.0</td>
          </tr>
          <tr>
            <td>tensorflow</td>
            <td>2.10.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>tensorflow-estimator</td>
            <td>2.10.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>tensorflow-io-gcs-filesystem</td>
            <td>0.27.0</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>termcolor</td>
            <td>2.1.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>threadpoolctl</td>
            <td>3.1.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>tomli</td>
            <td>2.0.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>tornado</td>
            <td>6.2</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>tqdm</td>
            <td>4.64.1</td>
            <td>MIT License; Mozilla Public License 2.0 (MPL 2.0)</td>
          </tr>
          <tr>
            <td>twisted-iocpsupport</td>
            <td>1.0.2</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>txaio</td>
            <td>22.2.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>typed-ast</td>
            <td>1.4.3</td>
            <td>Apache License 2.0</td>
          </tr>
          <tr>
            <td>typing-extensions</td>
            <td>4.4.0</td>
            <td>Python Software Foundation License</td>
          </tr>
          <tr>
            <td>urllib3</td>
            <td>1.26.12</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vine</td>
            <td>5.0.0</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>wcwidth</td>
            <td>0.2.5</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>wincertstore</td>
            <td>0.2</td>
            <td>Python Software Foundation License</td>
          </tr>
          <tr>
            <td>windows-curses</td>
            <td>2.3.1</td>
            <td>Python Software Foundation License</td>
          </tr>
          <tr>
            <td>wrapt</td>
            <td>1.14.1</td>
            <td>BSD License</td>
          </tr>
          <tr>
            <td>xgboost</td>
            <td>0.90</td>
            <td>Apache Software License</td>
          </tr>
          <tr>
            <td>zipp</td>
            <td>3.11.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>zope.interface</td>
            <td>5.5.0</td>
            <td>Zope Public License</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    </v-card>

    <h2 class="text-h4" id="javascript" v-intersect="onIntersect">JavaScript libraries</h2>

    <v-card flat outlined color="grey">
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Name</th>
            <th>Version</th>
            <th>License</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>axios</td>
            <td>0.21.4</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>camelcase</td>
            <td>7.0.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>core-js</td>
            <td>2.6.12</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>dataframe-js</td>
            <td>1.4.4</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>fontsource/roboto</td>
            <td>4.5.8</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>git-describe</td>
            <td>4.1.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>moment</td>
            <td>2.29.4</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>moment-range</td>
            <td>4.0.2</td>
            <td>Unlicense</td>
          </tr>
          <tr>
            <td>node-sass</td>
            <td>6.0.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>numeral</td>
            <td>2.0.6</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>percentile-rank</td>
            <td>1.0.6</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>plotly.js</td>
            <td>2.16.3</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>pluralize</td>
            <td>8.0.0</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>popper.js</td>
            <td>1.16.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>sass</td>
            <td>1.32.13</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>sass-loader</td>
            <td>10.4.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>statnett/vue-plotly</td>
            <td>0.3.2</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vue</td>
            <td>2.7.14</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vuedraggable</td>
            <td>2.24.3</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vue-native-websocket</td>
            <td>2.0.15</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vue-qrcode-component</td>
            <td>2.1.1</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vue-router</td>
            <td>3.6.5</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vuetify</td>
            <td>2.6.12</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vuex</td>
            <td>3.6.2</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>vuex-persist</td>
            <td>3.1.3</td>
            <td>MIT License</td>
          </tr>
          <tr>
            <td>xlsx</td>
            <td>0.17.5</td>
            <td>Apache 2.0</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    </v-card>

    <contents :items="menu" ref="contents" />
  </article>
</template>
<script>
import Contents from "@/components/contents"
export default {
  name: "HelpCredits",
  components: { Contents },
  data() {
    return {
      selected: "intro",
      menu: [
        { id: "credits", text: "Credits and Licenses", depth: 1 },
        { id: "python", text: "Python packages", depth: 1 },
        { id: "javascript", text: "JavaScript libraries", depth: 1 },
      ],
    }
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION
    },
  },
  methods: {
    onIntersect(entries, observer) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          let target = entry.target.id
          this.$refs.contents.selected = target
        }
      }
    },
  },
}
</script>
